import { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, Box } from "@mui/material";
import Header from "./components/Layout/Header";
import Footer from "./components/Layout/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import theme from "./theme/theme";
import authService from "./services/authService";

function App() {
  const [user, setUser] = useState(authService.getCurrentUser());

  const handleLogin = async () => {
    // TODO: Implement actual login flow
    const result = await authService.loginWithGoogle();
    if (result.success) {
      setUser(result.user);
    } else {
      console.log("Login not yet implemented. Set up Google OAuth to enable.");
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
          }}
        >
          <Header user={user} onLoginClick={handleLogin} />
          <Box component="main" sx={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
            </Routes>
          </Box>
          <Footer />
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
